import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Header from "./Header.jsx";
import axios from "axios";
import elips from "../Ellipse.png"
import exambpp from "../EXAMBPPP-logo.png";
import bobathanks from "../boba_thanks.png";
import { useNavigate } from "react-router-dom";
import { decrypt } from "./shares/GlobalFunction.jsx";
import { API_URL, SECRET_SESSION } from "../constants";
import { encrypt, encrypt_res, decrypt_res } from "./shares/GlobalFunction.jsx";
import Loader from "./shares/Loader.jsx";
import axiosInstance from "./shares/axiosConfig.js";
import moment from "moment-timezone";

const baseURL_Login = API_URL + "/login/info";

export const FinishTest = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [countdown, setCountdown] = useState(10);
  const [effectsCompleted, setEffectsCompleted] = useState(0);
  const [post, setPost] = React.useState(null);
  const [dataProjek, setDataProjek] = useState(null);
  const accessToken = localStorage.getItem("token");

  useEffect(() => {
    // Notify Android that the exam session has ended so it can relax restrictions.
    window.AndroidBridge?.notifyExamFinished();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  React.useEffect(() => {
    axios.post(baseURL_Login).then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
      setEffectsCompleted((prev) => prev + 1);
    });
  }, []);

  React.useEffect(() => {
    axios.post(API_URL + "/peserta/info_projek", {
      id_projek: userData.id_projek
    }, {headers: {Authorization: `Bearer ${accessToken}`}})
    .then((response) => {
      setDataProjek(response.data.res);
      // alert(JSON.stringify(response.data.res[0]))
    })
  }, []);

  useEffect(() => {

      //chek dataProjek jika masih null       
      if (dataProjek === null) {
        return; // Don't proceed if dataProjek is null
      }
      if (dataProjek && dataProjek.show_hasil===0) {

      if (countdown > 0){
        const timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(timer);
      } else {
        navigate("/peserta/logout");
        return;
        // console.log("waktu habis");
      }
    }
  }, [dataProjek, countdown, navigate])

  // localStorage.removeItem("statusJawaban");
  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    // redirect("/login");
    navigate("/login");
  }

  //cek info skor tes
  const [hasilTes, setHasilTes] = React.useState(null);
  React.useEffect(() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance
      .post(API_URL + "/peserta/info_hasil", {
        data: encryptedPayload,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          let decResponse = JSON.parse(
            decrypt_res(response.data.data, SECRET_SESSION)
          );

          setHasilTes(decResponse);
        } else {
          // navigate("/login");
        }
        setEffectsCompleted((prev) => prev + 1);
      });
  }, [navigate, userData.id_projek, userData.id_siswa]);

  useEffect(() => {
    if (effectsCompleted >= 2) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  const confirmLogout = () => {
    navigate("/peserta/logout");
  }

  return (
    <div className="App">
      <div 
        className="App-header"
        style={{backgroundColor: "white"}}
        >
        <Header app_name={post && post.alamat} />
        <img src={bobathanks} className="absolute top-[20%] right-0 object-cover z-0"></img>
        <div className={`flex h-screen flex-row w-full p-5 overflow-y-hidden relative ${
          !isMobile ? "px-20" : "px-0"
        }`}>
        <div
          className="login-container z-10 p-5 overflow-y-hidden relative"
          style={{
            minHeight: "200px",
            animation: "fadeInFromBottom 1s forwards",
          }}
        >
          <img
            src={exambpp}
            className="h-16 sm:h-24 md:h-24 lg:h-32 xl:h-32"  
            style={{marginTop: "60px"}}
          ></img>
          <div
            className="relative mt-12"
            style={{
              fontSize: "60px",
              fontFamily: '"Poppins", sans-serif',
              fontWeight: 300,
            }}
          >
            <img src={elips} className="absolute top-0 left-0 object-cover z-0"></img>
            <p className="z-10">Terimakasih!</p>
          </div>
          <div
            className="relative"
            style={{
              fontSize: "24px",
              fontFamily: '"Poppins", sans-serif',
              marginTop: "10px"
            }}>

            <p style={{fontWeight: 550, marginBottom: "10px", textAlign:"justify"}}>Anda sudah menyelesaikan tes {dataProjek ? dataProjek.nama: "ini"}</p>

            <div className="text-2xl">
              {dataProjek && dataProjek.show_hasil===1 && hasilTes
                ? hasilTes.map((item) => {
                  return Object.entries(item.skor_tes).map(([subtestName, score]) => {
                    if (parseInt(item.view_hasil) === 1 && subtestName === 'Skor Menjawab') {
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName] ?? 150}
                        </div>
                      );
                    } else if (parseInt(item.view_hasil) === 1 && subtestName === 'Skor Menjawab BK') {
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName] ?? 35}
                        </div>
                      );
                    } else if (parseInt(item.view_hasil) === 1 && subtestName === 'Verbal') {
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName] ?? 5}
                        </div>
                      );
                    } else if (parseInt(item.view_hasil) === 1 && subtestName === 'Numerik') {
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName] ?? 5}
                        </div>
                      );
                    } else if (parseInt(item.view_hasil) === 1 && subtestName === 'Figural') {
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName] ?? 5}
                        </div>
                      );
                    } else if (parseInt(item.view_hasil) === 1){
                      return (
                        <div
                          key={`${item.id}-${subtestName}`}
                          className="px-4 py-3 rounded-xl mb-4 border border-slate-600"
                        >
                          <span className="uppercase text-slate-600 font-bold">{subtestName}</span>
                          <br />
                          <span className="text-4xl font-bold">{score}</span> dari {item.skor_tes_total?.[subtestName]}
                        </div>
                      );
                    }
                  
                    return null; // do not render if condition is false
                  });
                    
                    return null;
                  })
                : ""}
            </div>
            
            {}
            {dataProjek && dataProjek.show_hasil===0 && <p style={{fontWeight: 200}}>Dalam waktu {countdown} detik Anda akan diarahkan kembali ke <br></br> halaman login atau anda bisa klik tombol di bawah ini.</p> }
            
            <button
              onClick={confirmLogout}
              className="backgroundColor text-white px-10 py-2 hover:bg-slate-600 rounded-3xl mt-4"
            >
              Keluar
            </button>
          </div>
        </div>
        </div>
        {/* <div
          className=" text-center login-container contentLogin z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-6 "
          style={{
            width: "450px",
            "min-height": "200px",
            "margin-top": "100px",
          }}
        >
          <div className="text-center font-bold text-xl mb-1 uppercase">
            Terima Kasih!
          </div>
          <div className="pb-4">
            Anda sudah berpartisipasi dalam tes ini. Silahkan klik tombol di
            bawah ini untuk menutup halaman tes.
          </div>

          <div>
            <div></div>
            <div className="">
              {hasilTes
                ? hasilTes.map((item) => {
                    if (parseInt(item.view_hasil) === 1) {
                      return (
                        <div
                          key={item.id}
                          className="border border-blue-400 text-blue-900 px-4 py-3 rounded mb-4"
                        >
                          <div>Skor {item.nama_projek}</div>
                          <div className="text-4xl">{item.jumlah_benar}</div>
                        </div>
                      );
                    }
                    return null;
                  })
                : ""}
            </div>
          </div>
          <NavLink
            to="/peserta/logout"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Keluar
          </NavLink>
        </div> */}
      </div>
    </div>
  );
};
// export default Login;
